import {CONTACT_ACTION_IDS} from '../contracts.js'

export const STICKY_BAR_LAYOUTS = {
  WHATSAPP: 'whatsappLayout',
  THREE_COLUMNS: 'threeColumns',
  TWO_COLUMNS: 'twoColumns',
  SINGLE_COLUMN: 'singleColumn'
}

const {PHONE, MESSAGE, WHATSAPP} = CONTACT_ACTION_IDS

const buildSlots = (ids, availableActions, isIconOnlyLayout) =>
  ids.map(id => ({
    id,
    iconOnly: isIconOnlyLayout && id !== WHATSAPP && Boolean(availableActions[id]?.iconOnlyCapable)
  }))

const deriveLayout = (availableActions = {}) => {
  const hasPhone = Boolean(availableActions[PHONE]?.available)
  const hasWhatsapp = Boolean(availableActions[WHATSAPP]?.available)

  const resolve = () => {
    if (hasWhatsapp && hasPhone) {
      return {
        layout: STICKY_BAR_LAYOUTS.WHATSAPP,
        ids: [PHONE, MESSAGE, WHATSAPP],
        isIconOnlyLayout: true
      }
    }

    if (hasWhatsapp) {
      return {
        layout: STICKY_BAR_LAYOUTS.TWO_COLUMNS,
        ids: [MESSAGE, WHATSAPP],
        isIconOnlyLayout: false
      }
    }

    if (hasPhone) {
      return {
        layout: STICKY_BAR_LAYOUTS.TWO_COLUMNS,
        ids: [PHONE, MESSAGE],
        isIconOnlyLayout: false
      }
    }

    return {
      layout: STICKY_BAR_LAYOUTS.SINGLE_COLUMN,
      ids: [MESSAGE],
      isIconOnlyLayout: false
    }
  }

  const {layout, ids, isIconOnlyLayout} = resolve()

  return {
    layout,
    slots: buildSlots(ids, availableActions, isIconOnlyLayout)
  }
}

export default deriveLayout
